<div class="main-content side-content pt-0 ml-0">
  <div class="main-container container-fluid">
    <div class="inner-body">
      <div class="row row-sm">

        <!-- LEFT SIDE - Original Upload UI -->
        <div [class]="isUploading ? 'col-lg-6 col-md-12' : 'col-lg-10 col-md-12'">
          <div class="card custom-card mt-5 shadow-sm border-0">
            <div class="card-body">

              <!-- Header Section -->
              <div class="row align-items-center mb-4">
                <div class="col-md-8 d-flex align-items-center">
                  <img src="../../assets/img/ExamMaster.png" alt="Logo" class="mh-45px pb-2" style="height: 45px;">
                  <div class="ml-3">
                    <h3 class="main-content-label mb-0 font-weight-bold">
                      Upload Student Data
                    </h3>
                    <small class="text-muted">Select your file to import student details.</small>
                  </div>
                </div>
              </div>

              <!-- File Upload Button -->
              <div class="row justify-content-start mb-4">
                <div class="col-md-6 col-sm-12">
                  <button type="button" class="btn btn-primary btn-block btn-icon-text position-relative"
                    [disabled]="isUploading" style="overflow: hidden;">
                    <span>{{ isUploading ? 'Upload in Progress...' : 'Select Excel/CSV File to Upload' }}</span>
                    <input type="file" accept=".xlsx,.xls,.csv" (change)="onFileSelected($event)"
                      [disabled]="isUploading"
                      style="position: absolute; top: 0; left: 0; opacity: 0; height: 100%; width: 100%; cursor: pointer;">
                  </button>
                </div>
              </div>

              <!-- Progress Bar Section -->
              <div class="row justify-content-start mb-4" *ngIf="isUploading">
                <div class="col-md-12 col-sm-12">
                  <div class="card bg-white border-0 p-4 shadow-sm">
                    <h5 class="mb-3 text-dark font-weight-bold">
                      <i class="fa fa-upload mr-2 text-primary"></i>
                      Upload in Progress
                    </h5>

                    <!-- Progress Information -->
                    <div class="mb-3">
                      <div class="d-flex justify-content-between mb-2">
                        <span class="text-secondary">Processing Record:</span>
                        <span class="font-weight-bold text-primary">{{ currentRecord }} of {{ totalRecords }}</span>
                      </div>
                      <div class="d-flex justify-content-between mb-2">
                        <span class="text-secondary">Progress:</span>
                        <span class="font-weight-bold text-info">{{ uploadProgress }}%</span>
                      </div>
                      <div class="d-flex justify-content-between mb-2">
                        <span class="text-secondary">Success:</span>
                        <span class="font-weight-bold text-success">{{ successCount }}</span>
                      </div>
                      <div class="d-flex justify-content-between mb-2">
                        <span class="text-secondary">Failed:</span>
                        <span class="font-weight-bold text-danger">{{ failCount }}</span>
                      </div>
                      <div class="d-flex justify-content-between mb-3">
                        <span class="text-secondary">Estimated Time Remaining:</span>
                        <span class="font-weight-bold text-warning">{{ estimatedTimeRemaining }}</span>
                      </div>
                    </div>

                    <!-- Progress Bar -->
                    <div class="progress-container mb-3">
                      <div class="progress">
                        <div class="progress-bar progress-bar-striped progress-bar-animated bg-primary"
                          role="progressbar" [ngStyle]="{'width': uploadProgress + '%'}"
                          [attr.aria-valuenow]="uploadProgress" aria-valuemin="0" aria-valuemax="100">
                          <span class="font-weight-bold">{{ uploadProgress }}%</span>
                        </div>
                      </div>
                    </div>

                    <!-- Keep Screen Active Message -->
                    <div class="alert alert-info mt-3 mb-0 d-flex align-items-center" role="alert">
                      <i class="fa fa-shield mr-2"></i>
                      <small>
                        <strong>Protected Mode Active:</strong> Screen will stay on and page refresh is blocked.
                        Do not close this tab.
                      </small>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Upload Summary (shown after completion) -->
              <div class="row justify-content-start" *ngIf="totalRecords > 0 && !isUploading">
                <div class="col-md-6 col-sm-12">
                  <div class="card bg-light border-0 p-3 shadow-sm">
                    <h5 class="mb-3 text-dark font-weight-bold">
                      <i class="fa fa-check-circle mr-2 text-success"></i>
                      Upload Summary
                    </h5>
                    <div class="d-flex justify-content-between mb-2">
                      <span class="text-secondary">Total Records:</span>
                      <span class="font-weight-bold text-dark">{{ totalRecords }}</span>
                    </div>
                    <div class="d-flex justify-content-between mb-2">
                      <span class="text-secondary">Successful Imports:</span>
                      <span class="font-weight-bold text-success">{{ successCount }}</span>
                    </div>
                    <div class="d-flex justify-content-between">
                      <span class="text-secondary">Failed Imports:</span>
                      <span class="font-weight-bold text-danger">{{ failCount }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Failed Record Download -->
              <div class="row mt-4" *ngIf="showDownloadButton">
                <div class="col-md-12 col-sm-12">
                  <div class="alert alert-warning d-flex justify-content-between align-items-center shadow-sm"
                    role="alert">
                    <div>
                      <i class="fa fa-exclamation-triangle mr-2"></i>
                      Some records failed validation. Please correct them and re-upload.
                    </div>
                    <button (click)="downloadFailedExcel()" class="btn btn-warning btn-sm">
                      <i class="fa fa-download mr-1"></i> Download Failed Records
                    </button>
                  </div>
                </div>
              </div>

            </div> <!-- card-body -->
          </div> <!-- card -->
        </div> <!-- col -->

        <!-- RIGHT SIDE - Real-Time Logs Panel (Only visible during upload) -->
        <div class="col-lg-6 col-md-12" *ngIf="isUploading">
          <div class="card custom-card mt-5 shadow-sm border-0 logs-panel-card">
            <div class="card-header bg-dark text-white d-flex justify-content-between align-items-center">
              <div>
                <h5 class="mb-0">
                  <i class="fa fa-list-alt mr-2"></i>
                  Real-Time Upload Logs
                </h5>
                <small class="text-light">Live processing status</small>
              </div>
              <div class="d-flex align-items-center">
                <span class="badge badge-success mr-2">
                  <i class="fa fa-check mr-1"></i>{{ logsSuccessCount }}
                </span>
                <span class="badge badge-danger mr-2">
                  <i class="fa fa-times mr-1"></i>{{ logsFailCount }}
                </span>
                <button class="btn btn-sm btn-outline-light mr-2" (click)="clearLogs()"
                  [disabled]="uploadLogs.length === 0">
                  <i class="fa fa-trash mr-1"></i> Clear
                </button>
                <span class="badge badge-light">{{ uploadLogs.length }} logs</span>
              </div>
            </div>
            <div class="card-body p-0 logs-panel-body">
              <div class="logs-container" #logsContainer>

                <!-- Loading indicator when no logs yet -->
                <div class="text-center py-5 text-muted" *ngIf="uploadLogs.length === 0">
                  <i class="fa fa-spinner fa-spin fa-2x mb-3"></i>
                  <p>Waiting for upload to start...</p>
                </div>

                <!-- Log entries -->
                <div class="log-entry" *ngFor="let log of uploadLogs; let i = index" [ngClass]="{
                       'log-success': log.result === true,
                       'log-error': log.result === false,
                       'log-info': log.result === null
                     }" [attr.data-index]="i">

                  <!-- Log Header -->
                  <div class="log-header">
                    <div class="log-icon">
                      <i class="fa" [ngClass]="{
                           'fa-check-circle': log.result === true,
                           'fa-times-circle': log.result === false,
                           'fa-info-circle': log.result === null
                         }"></i>
                    </div>
                    <div class="log-info">
                      <div class="log-prn">
                        <strong>PRN:</strong>
                        <span class="prn-number">{{ log.prnNo || 'N/A' }}</span>
                      </div>
                      <div class="log-time">
                        <i class="fa fa-clock-o mr-1"></i>
                        {{ log.timestamp | date:'HH:mm:ss' }}
                      </div>
                    </div>
                    <div class="log-status">
                      <span class="badge" [ngClass]="{
                              'badge-success': log.result === true,
                              'badge-danger': log.result === false,
                              'badge-info': log.result === null
                            }">
                        {{ log.result === true ? 'SUCCESS' : (log.result === false ? 'FAILED' : 'INFO') }}
                      </span>
                    </div>
                  </div>

                  <!-- Log Message -->
                  <div class="log-message" *ngIf="log.message">
                    <i class="fa fa-comment-o mr-2"></i>
                    <span>{{ log.message }}</span>
                  </div>

                  <!-- Log Details (expandable) -->
                  <div class="log-details" *ngIf="log.details">
                    <button class="btn btn-link btn-sm p-0" (click)="toggleLogDetails(i)">
                      <i class="fa" [ngClass]="log.expanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                      {{ log.expanded ? 'Hide' : 'Show' }} Details
                    </button>
                    <div class="details-content" *ngIf="log.expanded">
                      <pre>{{ log.details | json }}</pre>
                    </div>
                  </div>
                </div>

              </div> <!-- logs-container -->
            </div> <!-- card-body -->

            <!-- Logs Footer -->
            <div class="card-footer bg-light border-top">
              <div class="d-flex justify-content-between align-items-center">
                <small class="text-muted">
                  <i class="fa fa-circle text-success blink"></i> Live Updates
                </small>
                <div>
                  <label class="mb-0 mr-2">
                    <input type="checkbox" [(ngModel)]="autoScrollLogs" class="mr-1">
                    Auto-scroll
                  </label>
                </div>
              </div>
            </div>
          </div> <!-- card -->
        </div> <!-- col -->

      </div> <!-- row -->
    </div> <!-- inner-body -->
  </div> <!-- main-container -->
</div> <!-- main-content -->